import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { getStorageToken } from '@core/_utils/tools.utils';

@Injectable()
export class Communication {

    private urlApi = environment.apiUrl;
    private localToken = '';

    constructor(private http: HttpClient) {
        this.urlApi = this.getApiUrl(environment.apiUrlList, window.location.hostname);
    }

    private getApiUrl(apiUrlList: Array<{ [key: string]: string }>, key: string) {
        if (environment.apiUrl === '') {
            let obj = apiUrlList.find((value) => value[key]);
            if (obj) {
                return obj[key];
            }
        }
        return environment.apiUrl;
    }

    public getUrlGed() {
        return this.urlApi;
    }

    public getUrl(url) {
        interface Response {
            Request: Array<object>;
            Response: Array<object>;
        }
        const headers = new HttpHeaders().set('Authorization', `Bearer ${getStorageToken()}`);
        return this.http.get<Response>(this.urlApi + url,  { headers });
    }

    public postUrl(url, formData) {
        interface Response {
            Request: Array<object>;
            Response: Array<object>;
        }
        const headers = new HttpHeaders().set('Authorization', `Bearer ${getStorageToken()}`);
        return this.http.post<Response>(this.urlApi + url, formData, { headers });
    }

    public postUrlFile(url, formData) {
        interface Response {
            Request: Array<object>;
            Response: Array<object>;
        }
        //const headers = new HttpHeaders().set('Authorization', `Bearer ${getStorageToken()}`);
        let headers = new HttpHeaders().set('Authorization', `Bearer ${getStorageToken()}`);
        // let headers ={'headers' : new HttpHeaders ({'Content-Type' : 'application/json'}), 'responseType': 'text', observe:'response'})

        // headers.set('Content-Type', 'application/json');
        // headers.set('responseType', 'blob');
        // const httpOptions = {
        //     headers: headers,
        //     observe: 'response' as 'response',
        //     // responseType: 'blob'
        //   };
        return this.http.post(this.urlApi + url, formData, { headers, responseType: 'blob'});
        // return this.http.post(this.urlApi + url, formData,{'headers' : new HttpHeaders (
        //     {'Content-Type' : 'application/json'}),
        //      'responseType': 'blob', observe:'response'})
        //      ;
        // return this.http.post(this.urlApi + url, formData, httpOptions );
    }

    public getUrlFile(url, formData) {
        interface Response {
            Request: Array<object>;
            Response: Array<object>;
        }
        const headers = new HttpHeaders().set('Authorization', `Bearer ${getStorageToken()}`);
        let option = {options: headers, params: formData};
        return this.http.get(this.urlApi + url, option);
    }


    public putUrl(url, data) {
        interface Response {
            Request: Array<object>;
            Response: Array<object>;
        }
        const headers = new HttpHeaders().set('Authorization', `Bearer ${getStorageToken()}`);
        return this.http.put<Response>(this.urlApi + url, data, { headers });
    }

    public patchUrl(url, data) {
        interface Response {
            Request: Array<object>;
            Response: Array<object>;
        }
        const headers = new HttpHeaders().set('Authorization', `Bearer ${getStorageToken()}`);
        return this.http.patch<Response>(this.urlApi + url, data, { headers });
    }

    public deleteUrl(url) {
        interface Response {
            Request: Array<object>;
            Response: Array<object>;
        }
        const headers = new HttpHeaders().set('Authorization', `Bearer ${getStorageToken()}`);
        return this.http.delete<Response>(this.urlApi + url, { headers });
    }

    private getLocalToken() {
        if (getStorageToken()) {
            throw new Error('Token invalide ou session expirée, merci de vous identifier');
        } else {
            return this.localToken = getStorageToken();
        }
    }

}
